var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentTranslationAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 16.2503V3.75033C3.3335 3.19779 3.55299 2.66789 3.94369 2.27719C4.33439 1.88649 4.86429 1.66699 5.41683 1.66699H15.8335C16.0545 1.66699 16.2665 1.75479 16.4228 1.91107C16.579 2.06735 16.6668 2.27931 16.6668 2.50033V17.5003C16.6668 17.7213 16.579 17.9333 16.4228 18.0896C16.2665 18.2459 16.0545 18.3337 15.8335 18.3337H5.41683C4.86429 18.3337 4.33439 18.1142 3.94369 17.7235C3.55299 17.3328 3.3335 16.8029 3.3335 16.2503ZM3.3335 16.2503C3.3335 15.6978 3.55299 15.1679 3.94369 14.7772C4.33439 14.3865 4.86429 14.167 5.41683 14.167H16.6668",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 10.8333L9.99984 5L13.3332 10.8333",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5835 9.16699H12.3335",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentTranslationAdmin);
export default __webpack_public_path__ + "static/media/contentTranslationAdmin.e828ef47e43fa49bcd06e57d53d87734.svg";
export { ForwardRef as ReactComponent };